import React, { Component } from "react";
import "./App.css";
import { BrowserRouter, Route } from "react-router-dom";

import Home from "./views/home";
import Home2 from "./views/home2";
import Home3 from "./views/home3";
import Home4 from "./views/home4";
import Home5 from "./views/home5";
import Home6 from "./views/home6";
import Home7 from "./views/home7";

class App extends Component {
	render() {
		return (
			<BrowserRouter>
				<div>
					<Route
						exact={true}
						path="/"
						render={() => (
							<div className="Home">
								<Home />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/spray-decorating"
						render={() => (
							<div className="Home2">
								<Home2 />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/cladding-spraying"
						render={() => (
							<div className="Home3">
								<Home3 />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/ceiling-spraying"
						render={() => (
							<div className="Home4">
								<Home4 />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/shop-front-spraying"
						render={() => (
							<div className="Home5">
								<Home5 />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/roller-shutter-spraying"
						render={() => (
							<div className="Home5">
								<Home6 />
							</div>
						)}
					/>
					<Route
						exact={true}
						path="/intumescent-coatings"
						render={() => (
							<div className="Home6">
								<Home7 />
							</div>
						)}
					/>
				</div>
			</BrowserRouter>
		);
	}
}
export default App;



// WEBPACK FOOTER //
// ./src/App.js